import {mapGetters} from 'vuex';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtAutocomplete from '@/common/components/mvtautocomplete/mvt-autocomplete.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';

export default {
  name: 'staticWelcomeSearch',
  inject: ['$eventBus'],
  props: {
    imageUrl: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    searchType: {
        type: String,
        default: ''
    }
  },
  data: function() {
      return {
          searchInfo: {
              text: '',
              geo: null,
              extraPath: ''
          }
      };
  },
  watch:{
    searchInfo(newVal){
      if(newVal){
          this.$eventBus.$emit('eventbus-search', {
              text: newVal.text,
              geo: newVal.geo,
              isGoogleGeo: newVal.isGoogleGeo,
              isMlsNumber: newVal.isMlsNumber,
          });
      }
    }
  },
  components: {
    mvtInputGeo,
    mvtAutocomplete,
    mvtWelcome
  },
  computed: {
    ...mapGetters('glb', ['viewport', 'glb']),
      getAutoCompleteOpt() {
        return {
            filterType: this.searchType,
            includeAgentProfiles: true,
            hideDefaultSuggest: false,
            showGroupedSuggest: true,
        };
    },
    getPlaceHolderText(){
      switch(this.searchType){
        case 'Listings':
          return 'Search by State, City, ZIP';
        case 'Market Trends':
          return 'Search Trends by City, ZIP';
        case 'Schools':
          return  'Search Schools by City';
        case 'Agents':
          return 'Search Agents by City, ZIP';
      }
    }
  }
}